import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import {
  ArrowLeftIcon,
  UserIcon,
  PhoneIcon,
  AtSymbolIcon,
  AcademicCapIcon,
  CalendarDaysIcon,
} from '@heroicons/react/24/outline';
import { FORMA_LINK_BTN } from '../../utils/listPageUi';
import { useLanguage } from '../../contexts/LanguageContext';

const TrainerDetail = ({ trainer }) => {
  const { t } = useLanguage();

  if (!trainer) {
    return <div className="text-slate-900 dark:text-slate-50">{t('trainerDetail.notFound')}</div>;
  }

  return (
    <div className="space-y-6">
      <div className="mb-6">
        <Link
          to="/trainers"
          className="flex items-center text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-50"
        >
          <ArrowLeftIcon className="mr-2 h-5 w-5" />
          {t('trainerDetail.backToList')}
        </Link>
      </div>

      <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-soft dark:border-slate-700 dark:bg-slate-900/75">
        <div className="mb-8 flex flex-col items-center">
          <div className="mb-4 flex h-32 w-32 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-forma-500 to-forma-700 ring-4 ring-forma-100 dark:ring-forma-900/60">
            {trainer?.photo ? (
              <img src={trainer.photo} alt={trainer.name} className="h-full w-full object-cover" />
            ) : (
              <UserIcon className="h-16 w-16 text-white" />
            )}
          </div>
          <h2 className="mb-1 text-2xl font-semibold text-slate-900 dark:text-slate-50">{trainer.name}</h2>
          <p className="text-sm text-slate-600 dark:text-slate-400">{trainer.trainerCode}</p>
        </div>

        <div className="mb-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="rounded-lg bg-slate-100/80 p-4 dark:bg-slate-800/40">
            <div className="mb-2 flex items-center">
              <PhoneIcon className="mr-2 h-5 w-5 text-forma-600 dark:text-forma-400" />
              <span className="text-sm text-slate-700 dark:text-slate-300">{t('trainerDetail.phone')}</span>
            </div>
            <p className="text-slate-900 dark:text-slate-50">{trainer.phone}</p>
          </div>

          <div className="rounded-lg bg-slate-100/80 p-4 dark:bg-slate-800/40">
            <div className="mb-2 flex items-center">
              <AtSymbolIcon className="mr-2 h-5 w-5 text-forma-600 dark:text-forma-400" />
              <span className="text-sm text-slate-700 dark:text-slate-300">{t('trainerDetail.email')}</span>
            </div>
            <p className="text-slate-900 dark:text-slate-50">{trainer.email || t('trainerDetail.notProvidedM')}</p>
          </div>

          <div className="rounded-lg bg-slate-100/80 p-4 dark:bg-slate-800/40">
            <div className="mb-2 flex items-center">
              <AcademicCapIcon className="mr-2 h-5 w-5 text-forma-600 dark:text-forma-400" />
              <span className="text-sm text-slate-700 dark:text-slate-300">{t('trainerDetail.speciality')}</span>
            </div>
            <p className="text-slate-900 dark:text-slate-50">{trainer.specialty || t('trainerDetail.notProvidedF')}</p>
          </div>

          <div className="rounded-lg bg-slate-100/80 p-4 dark:bg-slate-800/40">
            <div className="mb-2 flex items-center">
              <CalendarDaysIcon className="mr-2 h-5 w-5 text-forma-600 dark:text-forma-400" />
              <span className="text-sm text-slate-700 dark:text-slate-300">{t('trainerDetail.joinDate')}</span>
            </div>
            <p className="text-slate-900 dark:text-slate-50">
              {new Date(trainer.joinDate).toLocaleDateString()}
            </p>
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <Link to={`/trainers/edit/${trainer.id}`} className={clsx(FORMA_LINK_BTN, 'px-6 py-3')}>
            {t('trainerDetail.edit')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TrainerDetail;
